<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{params.title}}</div>
    <div slot="body">
      <dialog-selected-tips :name="$t('dictionary.user')" :count="params.data.length" :action="params.title" />
      <dialog-table :data="params.data" :columns="params.columns.slice(0, 3)" />
      <a-form-model
        v-if="showPassword"
        ref="form"
        :model="fd"
        :rules="rules"
        v-bind="formItemLayout">
        <a-form-model-item :label="$t('cloudenv.clouduser_list_t2')" prop="password" :extra="$t('iam.clouduser_password')">
          <a-input-password v-model="fd.password" :placeholder="$t('validator.password')" />
        </a-form-model-item>
        <a-form-model-item :label="$t('cloudenv.enable_mfa')" prop="enable_mfa" v-if="!isAllAws" :extra="hasAws ? $t('iam.enable_mfa_extra') : ''">
          <a-switch v-model="fd.enable_mfa" />
        </a-form-model-item>
      </a-form-model>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{ $t('dialog.ok') }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'
import expectStatus from '@/constants/expectStatus'
import { REGEXP } from '@/utils/validate'

export default {
  name: 'ClouduserSetConsoleLoginDialog',
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      loading: false,
      fd: {
        password: '',
        enable_mfa: false,
      },
      rules: {
        password: [
          {
            validator: (rule, value, cb) => {
              if (!this.fd.password) {
                cb()
              } else {
                const { regexp, message } = REGEXP.password
                if (regexp.test(this.fd.password)) {
                  cb()
                } else {
                  cb(Error(message))
                }
              }
            },
          },
        ],
      },
      formItemLayout: {
        wrapperCol: {
          span: 21,
        },
        labelCol: {
          span: 3,
        },
      },
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    showPassword () {
      return this.params.action === 'enable-console-login'
    },
    isAllAws () {
      return this.params.data.every(item => item.brand === 'Aws')
    },
    hasAws () {
      return this.params.data.some(item => item.brand === 'Aws')
    },
  },
  destroyed () {
  },
  created () {
  },
  methods: {
    async handleConfirm () {
      this.loading = true
      const { data = [], onManager } = this.params
      const params = (this.showPassword && this.fd.password) ? { password: this.fd.password, enable_mfa: this.fd.enable_mfa } : { enable_mfa: this.fd.enable_mfa }
      try {
        if (this.showPassword) {
          await this.$refs.form.validate()
        }
        await onManager('batchPerformAction', {
          id: data.map(({ id }) => {
            return id
          }),
          steadyStatus: Object.values(expectStatus.clouduser).flat(),
          managerArgs: {
            action: this.params.action,
            data: params,
          },
        })
        // this.params.singleRefresh()
        this.cancelDialog()
      } catch (error) {
        this.loading = false
        throw error
      }
    },
  },
}
</script>
